module.exports = __webpack_public_path__ + "static/img/icon_zylx02.ee97b89f.png";